import { useQuery } from '@tanstack/react-query';
import { fetchTeachersDataForTeacherWithSchoolId } from '../api/teachers';

const useFetchTeachersDataForLogin = (uid, schoolId, enabled = true) => {
  return useQuery({
    queryKey: ['fetchTeachersDataForTeacherWithSchoolId', uid, schoolId],
    queryFn: async () => {
      if (!uid || !schoolId) {
        throw new Error('UID and School ID are required');
      }
      
      const fetchedData = await fetchTeachersDataForTeacherWithSchoolId(uid, schoolId);

      console.log('fetchedData for teachersssssssssssss', fetchedData)
      
      if (!fetchedData) {
        throw new Error('Failed to fetch teachers data');
      }
      
      return fetchedData?.map((teacher) => ({
        id: teacher.uid,
        name: teacher.info?.name || teacher.info?.fullname || '',
        email: teacher.info?.email || '',
        photoURL: teacher.info?.photoURL || null,
        schoolName: teacher.info?.schoolName || '',
        schoolId: teacher.info?.schoolId || '',
        organizationId: teacher.info?.organizationId || '',
        status: teacher.info?.status || 'active',
        permissions: teacher.info?.permissions || {},
        qualifications: teacher.info?.qualifications || [],
        grade: teacher.info?.grade || '',
        schoolType: teacher.info?.schoolType || '',
        addStudent: teacher.info?.addStudent || false,
        subRole: teacher.info?.subRoleName || '',
        // Include any other teacher data that might be needed
        ...teacher.info,
      })) || [];
    },
    enabled: enabled && !!uid && !!schoolId,
    staleTime: 60000, // 1 min
    cacheTime: 300000, // 5 min
    retry: 2,
    retryDelay: 1000,
  });
};

export default useFetchTeachersDataForLogin; 